import { Button, Col, Modal, Row, Table, Tabs } from 'antd';
import { Bar, Column } from '@ant-design/charts';

import { CloseOutlined } from '@ant-design/icons';
import TabPane from 'antd/es/tabs/TabPane.js';
import React, { useState } from 'react';
import { customChartTooltip } from '../../utils/custom-chart-tooltip.jsx';

function PhaseBarComponent({ data, onClose, phase }) {
  const [tab, setTab] = useState('project_count');

  const columns = {
    1: 'project_count',
    2: 'people_count',
    3: 'taxes',
  };

  const phaseNames = {
    1: 'Прединвестиционная',
    2: 'Инвестиционная',
    3: 'Эксплуатационная',
  };

  const alias = {
    project_count: 'Кол-во проектов',
    people_count: 'Кол-во раб. мест',
    taxes: 'Налоги (млрд тг)',
  };

  const numbersData = data[tab][phase].map((d) => ({
    ...d,
    [tab]: Number(d[tab]),
  }));

  return (
    <div>
      <Row id={'phaseBar'} justify={'space-between'}>
        <div style={{ display: 'flex', gap: 4, flex: 1 }}>
          <span style={{ fontSize: '12px', fontWeight: '700' }}>
            {phase} стадия
          </span>
          <span style={{ fontSize: '12px', fontWeight: '700' }}>
            ({phaseNames[phase]})
          </span>
        </div>
        <Tabs
          defaultActiveKey="project_count"
          tabBarGutter={16}
          onChange={(key) => setTab(key)}
        >
          <TabPane
            tab={
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>Кол-во проектов</span>
              </div>
            }
            key="project_count"
          />

          <TabPane
            tab={
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>Кол-во раб. мест</span>
              </div>
            }
            key="people_count"
          />

          <TabPane
            tab={
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span>Налоги (млрд тг)</span>
              </div>
            }
            key="taxes"
          />
        </Tabs>
        <Button
          size={'small'}
          onClick={onClose}
          icon={<CloseOutlined />}
          style={{ marginLeft: 8 }}
        />
      </Row>

      <div style={{ height: '120px' }}>
        <Column
          style={{ marginTop: '8px', height: '100%' }}
          xField="year"
          yField={tab}
          data={numbersData ?? []}
          tooltip={customChartTooltip}
          // yAxis={{
          //   label: null, // ← убрать цифры
          //   title: null, // ← если есть заголовок, убрать тоже
          //   grid: null, // ← если хочешь ещё убрать линии
          // }}
          columnStyle={{
            radius: [20, 20, 0, 0],
            fill: 'l(90) 0:#3243FD',
          }}
          minColumnWidth={14}
          maxColumnWidth={14}
          padding={[15, 10, 20, tab === 'project_count' ? 30 : 55]}
          xAxis={{ label: { style: { fontWeight: 500, fontSize: 14 } } }}
          yAxis={{
            label: {
              formatter: (v) => {
                return v
                  ? new Intl.NumberFormat('ru-KZ', {
                      notation: 'compact',
                    }).format(v)
                  : '';
              },
            },
          }}
          label={{
            style: { fontSize: 15 },
            position: 'left-middle',
            offset: 8,
            layout: [],
            formatter: (v) => {
              return v[tab]
                ? new Intl.NumberFormat('ru-KZ', {
                    notation: 'standard',
                  }).format(Math.round(v[tab]))
                : '';
            },
          }}
          meta={{
            [tab]: { alias: alias[tab] },
          }}
        />
      </div>
    </div>
  );
}

export default PhaseBarComponent;
